import { first } from 'lodash';

import PLAN_NAME from 'constants/plan.const';
import withOptions from 'utils/functions/withOptions.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const determineDefaultTimeOffCategory = withOptions(({ categories, pricingPlanName, pricingPlanId }) => {
  if (!isFullArray(categories)) return void 1;

  const canHaveDefault = pricingPlanName === PLAN_NAME.essential || pricingPlanId === null;
  if (!canHaveDefault) return void 1;

  for (const category of categories) {
    // eslint-disable-next-line no-continue
    if (!category) continue;
    if (category.is_default || category.isDefault) return category;
  }

  return first(categories) || void 1;
});

export default determineDefaultTimeOffCategory;
